<template>
  <svg width="37" height="35" viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="31.5"
      y="34.5"
      width="31"
      height="31"
      rx="15.5"
      transform="rotate(-180 31.5 34.5)"
      fill="#25B7A6"
    />
    <rect
      x="31.5"
      y="34.5"
      width="31"
      height="31"
      rx="15.5"
      transform="rotate(-180 31.5 34.5)"
      stroke="#18A998"
    />
    <path
      d="M15.9998 22.6571L15.9998 24.4857M13.257 25.4L18.7427 25.4M10.5141 22.6571L21.4855 22.6571C22.4954 22.6571 23.3141 21.8384 23.3141 20.8285L23.3141 14.4285C23.3141 13.4187 22.4954 12.6 21.4855 12.6L10.5141 12.6C9.50423 12.6 8.68555 13.4187 8.68555 14.4285L8.68555 20.8285C8.68555 21.8384 9.50422 22.6571 10.5141 22.6571Z"
      stroke="white"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23 8C23 4.68629 25.6863 2 29 2C32.3137 2 35 4.68629 35 8C35 11.3137 32.3137 14 29 14C25.6863 14 23 11.3137 23 8Z"
      fill="white"
    />
    <path
      v-if="isSuccess"
      d="M31.0947 6.65533L28.25 9.5L27.2803 8.53033M29 2C25.6863 2 23 4.68629 23 8C23 11.3137 25.6863 14 29 14C32.3137 14 35 11.3137 35 8C35 4.68629 32.3137 2 29 2Z"
      stroke="#25B7A6"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      v-if="!isSuccess"
      d="M31.3865 6.14385C31.5329 5.9974 31.5329 5.75996 31.3865 5.61352C31.24 5.46707 31.0026 5.46707 30.8562 5.61352L31.3865 6.14385ZM26.6135 9.85615C26.4671 10.0026 26.4671 10.24 26.6135 10.3865C26.76 10.5329 26.9974 10.5329 27.1438 10.3865L26.6135 9.85615ZM30.8562 10.3865C31.0026 10.5329 31.24 10.5329 31.3865 10.3865C31.5329 10.24 31.5329 10.0026 31.3865 9.85615L30.8562 10.3865ZM27.1438 5.61351C26.9974 5.46707 26.76 5.46707 26.6135 5.61351C26.4671 5.75996 26.4671 5.9974 26.6135 6.14384L27.1438 5.61351ZM34.625 8C34.625 11.1066 32.1066 13.625 29 13.625L29 14.375C32.5208 14.375 35.375 11.5208 35.375 8L34.625 8ZM29 13.625C25.8934 13.625 23.375 11.1066 23.375 8L22.625 8C22.625 11.5208 25.4792 14.375 29 14.375L29 13.625ZM23.375 8C23.375 4.8934 25.8934 2.375 29 2.375L29 1.625C25.4792 1.625 22.625 4.47918 22.625 8L23.375 8ZM29 2.375C32.1066 2.375 34.625 4.8934 34.625 8L35.375 8C35.375 4.47919 32.5208 1.625 29 1.625L29 2.375ZM30.8562 5.61352L28.7348 7.73483L29.2652 8.26516L31.3865 6.14385L30.8562 5.61352ZM28.7348 7.73483L26.6135 9.85615L27.1438 10.3865L29.2652 8.26516L28.7348 7.73483ZM31.3865 9.85615L29.2652 7.73483L28.7348 8.26516L30.8562 10.3865L31.3865 9.85615ZM29.2652 7.73483L27.1438 5.61351L26.6135 6.14384L28.7348 8.26516L29.2652 7.73483Z"
      fill="#FB7185"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isSuccess: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
